<template>
  <div class="elevation-5 signing">
    <div class="logo-wrapper">
      <div class="logo"></div>
    </div>
    <div class="sign-box">
      <div class="input-box" v-if="!isSuccess">
        <p class="title">
          <i class="fas fa-key fa-fw"></i>
          ENTER PASSWORD
        </p>
        <v-form v-model="valid" ref="form">
          <div class="form-input">
            <v-text-field
              v-model="password1"
              type="password"
              placeholder="Password"
              :rules="[password1Rules.required, password1Rules.password1]"
              full-width
            ></v-text-field>
          </div>
          <div class="form-input">
            <v-text-field
              v-model="password2"
              type="password"
              placeholder="New password"
              :rules="[password2Rules.required, password2Rules.password2]"
              full-width
            ></v-text-field>
          </div>
          <v-btn
            class="btn-login reset-pwd mb-5"
            large block
            @click.native="resetPassword"
            :disabled="!valid"
          >Change Password</v-btn>
        </v-form>
      </div>
      <div class="input-box" v-else>
        <p class="title">
          <i class="fas fa-exclamation-triangle fa-fw"></i>
          PASSWORD CHANGE FAILED
        </p>
      </div>
    </div>
    <p class="copyright">COPYRIGHT ⓒImGATE ALL RIGHTS RESERVED.</p>
  </div>
</template>

<script>
  import api from '../../api';

  export default {
    data() {
      return {
        isSuccess: false,
        password1: null,
        password2: null,
        password1Rules: {
          required: value => (value === 0) || !!value || 'Please input Password.',
          password1: (value) => {
            const pattern = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,}$/;
            // const pattern = /^(?=.[0-9])(?=.[a-zA-Z])(?=.*[@#$%^&+=!?/_:;~])(?=\S+$).{8,}$/;
            return pattern.test(value) || 'Invalid password.';
          },
        },
        password2Rules: {
          required: value => (value === 0) || !!value || 'Please input Password.',
          password2: (value) => {
            const pattern = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,}$/;
            // const pattern = /^(?=.[0-9])(?=.[a-zA-Z])(?=.*[@#$%^&+=!?/_:;~])(?=\S+$).{8,}$/;
            return pattern.test(value) || 'Invalid password.';
          },
        },
        valid: true,
      };
    },
    mounted() {
      this.token = this.$route.params.token;
    },
    methods: {
      /**
       * @description 패스워드 체크 후 성공 실패 반환
       * @returns { Boolean }
       */
      checkPwd() {
        return (this.password !== this.passwordConfirm);
      },
      resetPassword() {
        if (this.$refs.form.validate()) {
          const token = this.$route.params.token;
          console.log(`token: ${token}`);
          const password = {
            password1: this.password1,
            password2: this.password2,
          };
          console.log(`token: ${this.token}`);
          api.resetPassword(token, password)
          .then((result) => {
            if (result.status === 200) {
              this.alert.type = 'check_circle';
              this.alert.color = 'green';
              this.alert.message = 'Success password change';
              this.alertOccur();
              this.isSuccess = false;
            }
          })
          .catch((err) => {
            this.alert.type = 'error';
            this.alert.color = 'red';
            this.alert.message = err.response.data.message;
            this.alertOccur();
            this.isSuccess = false;
          });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/signing/PwdResetConfirm.vue